var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"chinese btn bg-teal-500 btn mt-8 px-3 py-1 text-base \n\tsm:text-xl md:text-2xl lg:text-3xl xl:text-4xl rounded-md",attrs:{"to":{ name: _vm.changeRoute }}},[_vm._v(" Get Started | 开始 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }